import React from 'react'
import { View, TouchableOpacity, FlatList, Image } from 'react-native'
import { AppModal as Modal } from '@components'
import { useTheme } from '@react-navigation/native'
import { Text, Icon } from '@components'
import { useLanguage } from '@context'
import getStyle from './membersStyle'

interface GroupMember {
  id: string
  name: string
  avatar: any
  isAdmin?: boolean
}

interface GroupMembersModalProps {
  visible: boolean
  onClose: () => void
  members: GroupMember[]
  onRemoveMember: (memberId: string) => void
}

export const GroupMembersModal: React.FC<GroupMembersModalProps> = ({
  visible,
  onClose,
  members,
  onRemoveMember
}) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)

  const renderMember = ({ item, index }: { item: GroupMember; index: number }) => (
    <View style={styles.memberItem}>
      <View style={styles.memberInfo}>
        <Image source={{uri: item.avatar}} style={styles.memberAvatar} />
        <Text type="body" style={styles.memberName}>
          {item.name}
        </Text>
      </View>
      
      {/* Indicateur bleu pour le premier membre (admin) */}
      {index === 0 && (
        <View style={styles.adminIndicator} />
      )}
      
      {/* Bouton de suppression pour les autres membres */}
      {index !== 0 && (
        <TouchableOpacity 
          style={styles.removeButton}
          onPress={() => onRemoveMember(item.id)}
        >
          <Icon name="trash" size={20} color={theme.colors.error} />
        </TouchableOpacity>
      )}
    </View>
  )

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableOpacity 
        style={styles.modalOverlay}
        activeOpacity={1}
        onPress={onClose}
      >
        <TouchableOpacity 
          style={styles.modalContainer}
          activeOpacity={1}
        >
          {/* Header du modal */}
          <View style={styles.modalHeader}>
            <View style={styles.headerLeft}>
              <Text type="title" style={styles.modalTitle}>
                {t('messagesScreen.members')}
              </Text>
              <Text type="body" style={styles.memberCount}>
                {t('messagesScreen.persons', {count: members.length})}
              </Text>
            </View>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Icon name="cross" size={20} color={theme.colors.secondary} />
            </TouchableOpacity>
          </View>

          {/* Liste des membres */}
          <FlatList
            data={members}
            renderItem={renderMember}
            keyExtractor={(item) => item.id}
            style={styles.membersList}
            showsVerticalScrollIndicator={false}
          />
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  )
} 